import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState({});
  useEffect(() => {
    api.get("/testimonials").then(r => setItems(r.data.items || [])).catch(() => {});
  }, []);
  if (items.length === 0) return null;

  const CHARS_PREVIEW = 320;

  return (
    <section data-testid="testimonials" className="bg-[#F5F0E6] py-24 md:py-32 relative overflow-hidden">
      {/* Subtle paper texture accent */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{backgroundImage:"radial-gradient(#2C2621 1px, transparent 1px)", backgroundSize:"24px 24px"}}/>
      <div className="max-w-6xl mx-auto px-6 md:px-12 relative">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <p className="font-hand text-2xl text-[#A3876A] mb-3">Elles m'écrivent</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#2C2621] leading-tight">
            Des mots reçus,<br/><em className="italic">gardés près du cœur</em>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 md:gap-14">
          {items.map((t, i) => {
            const isLong = (t.quote || "").length > CHARS_PREVIEW;
            const isOpen = !!expanded[t.testimonial_id];
            const display = (!isLong || isOpen) ? t.quote : t.quote.slice(0, CHARS_PREVIEW).trimEnd() + "…";
            // Alternate slight vertical offset for magazine feel
            const offset = i % 2 === 1 ? "md:mt-16" : "";
            return (
              <article
                key={t.testimonial_id}
                data-testid={`testimonial-${t.testimonial_id}`}
                className={`relative bg-[#FDFBF7] border border-[#E8DCC8] p-10 md:p-12 shadow-[0_8px_24px_-12px_rgba(44,38,33,0.15)] ${offset}`}
              >
                <span aria-hidden="true"
                  className="absolute -top-6 left-8 font-serif text-8xl leading-none text-[#DCCBBA] select-none">
                  &ldquo;
                </span>
                <blockquote className="relative">
                  {display.split(/\n\n+/).filter(Boolean).map((p, j) => (
                    <p key={j} className="font-serif italic text-[#2C2621] text-lg md:text-xl leading-[1.7] mb-4 last:mb-0">
                      {p}
                    </p>
                  ))}
                </blockquote>

                {isLong && (
                  <button
                    onClick={() => setExpanded(prev => ({...prev, [t.testimonial_id]: !prev[t.testimonial_id]}))}
                    className="mt-4 text-sm text-[#A3876A] hover:text-[#8A7158] underline underline-offset-4 tracking-wide"
                    data-testid={`testimonial-toggle-${t.testimonial_id}`}
                  >
                    {isOpen ? "Lire moins" : "Lire la suite"}
                  </button>
                )}

                <div className="flex items-center gap-4 pt-8 mt-8 border-t border-[#E8DCC8]">
                  {t.photo_url ? (
                    <img src={t.photo_url} alt={t.name} className="w-12 h-12 rounded-full object-cover"/>
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-[#F5F0E6] flex items-center justify-center">
                      <span className="font-hand text-xl text-[#A3876A]">{(t.name || "").charAt(0)}</span>
                    </div>
                  )}
                  <div>
                    <p className="font-hand text-xl text-[#A3876A] leading-none">— {t.name}</p>
                    {t.context && <p className="text-xs text-[#7C7064] mt-1.5 tracking-wide uppercase">{t.context}</p>}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
